module.exports = __webpack_public_path__ + "img/sld_battery_2_dark.46029662.svg";